import { ADD_NOTIFICATION, DELETE_NOTIFICATION } from '../mutation-types';
import uniqueId from 'lodash/uniqueId';
import { defineStore } from "pinia";

export const useNotificationsStore = defineStore('notificationsModule', {
    state: () => ({
        notifications: []
    }),
    actions: {
        [ADD_NOTIFICATION](notification) {
            this.notifications.unshift({
                id: uniqueId('notification-'),
                ...notification
            });
        },
        [DELETE_NOTIFICATION](id) {
            this.notifications.splice(
                this.notifications.findIndex(element => element.id === id),
                1
            );
        }
    }
});
